import { type ContentColumnReadContent } from '../content-column-read.ts';

export type PageDetailsReadContent = ContentColumnReadContent<'page-details'>;

export const EMPTY_PAGE_DETAILS_CONTENT: PageDetailsReadContent = Object.freeze({
  kind: 'page-details',
  loadingWidth: 0,
  openLinksInNewTab: false,
  items: Object.freeze([])
});
